/**
 * Theme initialization - runs before CSS to prevent flash
 * Must be loaded synchronously (not as module) in <head>
 *
 * Stored preference first, prefers-color-scheme as the fallback. No cookie is
 * written until the user explicitly toggles, so an undecided visitor keeps
 * following the OS — including live changes while the page is open.
 */
(function() {
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    function savedTheme(): string | null {
        var match = document.cookie.match(/(?:^|; )theme=(light|dark)(?:;|$)/);
        return match ? match[1] : null;
    }
    function applyTheme(): void {
        var saved = savedTheme();
        document.documentElement.dataset.theme = saved || (mq.matches ? 'dark' : 'light');
    }
    applyTheme();
    mq.addEventListener('change', function() {
        if (!savedTheme()) {
            applyTheme();
        }
    });
})();
